import React, { Component } from 'react';

// import './styles.css';
import AudioAnalyser from './AudioAnalyser';
import Canvas from './Canvas';

// https://medium.com/swlh/create-an-audio-visualizer-with-react-and-canvas-part-1-of-3-da414a1edfed

class MusicExample extends Component {
    constructor(props) {
        super(props);
        this.state = {
            audio: null,
            // mp3: null
        };
        this.toggleMicrophone = this.toggleMicrophone.bind(this);
        // this.toggleMp3File = this.toggleMp3File.bind(this);
    }

    async getMicrophone() {
        const audio = await navigator.mediaDevices.getUserMedia({
            audio: true,
            video: false
        });
        this.setState({ audio });
    }

    stopMicrophone() {
        this.state.audio.getTracks().forEach(track => track.stop());
        this.setState({ audio: null });
    }

    toggleMicrophone() {
        if (this.state.audio) {
            this.stopMicrophone();
        } else {
            this.getMicrophone();
        }
    }

    vibrate = () => window.navigator.vibrate(200);


    render() {
        return(
            <div className="App">
                <div className="vibrate-button">
                    <button onClick={this.vibrate} >VIBRATE</button>
                </div>
                <div className="controls">
                    <button onClick={this.toggleMicrophone}>
                        {this.state.audio ? 'Stop microphone' : 'Get microphone input'}
                    </button>
                </div>
                { this.state.audio ? <AudioAnalyser audio={this.state.audio} /> : '' }
                <div>
                    <Canvas />
                </div>
            </div>
        );
    }

}

export default MusicExample;
